/*
 *
 * Communications constants
 *
 */

export const FLUSH_STATE_COMMUNICATIONS =
  'app/CommunicationsMobile/FLUSH_STATE_COMMUNICATIONS';

// LOAD
export const LOAD_COMMUNICATIONS = 'app/CommunicationsMobile/LOAD_COMMUNICATIONS';
export const LOAD_COMMUNICATIONS_SUCCESS =
  'app/CommunicationsMobile/LOAD_COMMUNICATIONS_SUCCESS';
export const LOAD_COMMUNICATIONS_ERROR =
  'app/CommunicationsMobile/LOAD_COMMUNICATIONS_ERROR';